// src/stone/icons/User2X.tsx
import { jsx } from "react/jsx-runtime";
var User2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M6.477 26.584A8.37 8.37 0 0 1 12.5 24h15c2.266 0 4.432.934 6.023 2.584A8.93 8.93 0 0 1 36 32.778v3.889a1 1 0 1 1-2 0v-3.89c0-1.808-.693-3.536-1.916-4.805A6.37 6.37 0 0 0 27.5 26h-15a6.37 6.37 0 0 0-4.583 1.972A6.93 6.93 0 0 0 6 32.778v3.889a1 1 0 1 1-2 0v-3.89c0-2.316.887-4.544 2.477-6.193M20.833 4.333a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m-8.5 6.5a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0" })
  }
);
var User2X_default = User2X;

export {
  User2X_default
};
